import { onINP } from 'web-vitals';

const interactionToNextPaint = (trackPerformanceMetricEvent) => {
  onINP((metric) => {
    trackPerformanceMetricEvent({
      metric_name: 'interaction-to-next-paint',
      metric_type: 'custom',
      metric_value: metric.value,
    });
  });
};

export default interactionToNextPaint;
